import { Signal } from "type-signals";
import { Tween } from "@westpierstudio/luma/createjs";


export class SkippableDelay {
    complete = new Signal();

    startSkippableDelay(duration: number) {
        Tween.get(this)
            .wait(duration)
            .call(() => this.complete.dispatch());
        return this.complete;
    }

    skip() {
        Tween.removeTweens(this);
        this.complete.dispatch();
    }
}
